<template>
  <div v-editable="blok">
    <div class="video">
      <iframe
        class="max-w-[748px] mx-auto"
        width="100%"
        height="420"
        :src="videoID"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VideoBlokProps } from '@/types';

const props = defineProps<{
  blok: VideoBlokProps;
}>();

const videoID = computed(() => {
  if (props.blok.videoURL.startsWith('https://www.youtube.com/watch?v=')) {
    return 'https://www.youtube.com/embed/' + props.blok.videoURL.split('=')[1];
  } else if (props.blok.videoURL.startsWith('https://youtu.be/')) {
    return 'https://www.youtube.com/embed/' + props.blok.videoURL.split('/')[3];
  }
});
</script>

<style lang="scss">
.video {
  @include container;

  padding-block-start: var(--spacing-s);
}
</style>
